"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceHandler = void 0;
const message_1 = require("../message");
const base_handler_1 = require("./base_handler");
class ServiceHandler extends base_handler_1.BaseHandler {
    constructor(connection, id, callback) {
        super(connection, id);
        this.callback = callback;
    }
    handleMessage(message) {
        super.handleMessage(message);
        if (message.type === message_1.MessageType.SERVICE_RESPONSE) {
            if (String(message.content["service_id"]) === this.id) {
                const result = this.callback(message.content["request"]);
                if (result instanceof Promise) {
                    result.then((response) => {
                        this.sendResponse(message, {
                            service_id: this.id,
                            response: response,
                        });
                    });
                }
                else {
                    this.sendResponse(message, {
                        service_id: this.id,
                        response: result,
                    });
                }
            }
        }
    }
    async destroy() {
        await this.sendRequest(message_1.MessageType.DESTROY_SERVICE, {
            service_id: this.id,
        });
        this.cleanUp();
    }
}
exports.ServiceHandler = ServiceHandler;
